// extracted by mini-css-extract-plugin
module.exports = {"helpCenterText":"HelpCenterPage_helpCenterText__2J2kd"};